import {makeStyles} from '@material-ui/core/styles'
import {Text} from '../../1elements'
import CollapseForCard from '../../2compounds/CollapseForCard'
import List from '@mui/material/List'
import UserListItem from '../../2compounds/UserListItem'
import {useEffect, useState} from 'react'
import SelectUsersModal from './SelectUsersModal'
import {deepCopyObjectArray, removeItemFromArray} from '../../../services/util/miscellaneousService'

const AssignOwner = ({users, setUsers, owner, showError}) => {
    const classes = useStyles()
    const [open, setOpen] = useState(false)
    const openModal = () => {
        setOpen(true)
    }

    const header = (
        <>
            Assigned User
            <span className={'requiredAsterisk'}>*</span>
        </>
    )

    const assignedUserCount = owner ? users.length + 1 : users.length

    const deleteHandler = (userId) => {
        const updatedList = removeItemFromArray(users, userId, 'user_id')
        setUsers(updatedList)
    }

    const errorHandler = () => {
        if(showError&&!assignedUserCount){
            return 'Assign at least one user'
        }
    }

    const ownerIndex = (users, owner) => {
        const doesUsersAndOwnerExist = users.length && owner
        if(doesUsersAndOwnerExist){
            return users.findIndex( user => user.user_id === owner.user_id)
        }
        return -1
    }

    useEffect(()=>{
        const ownerIndexInUsersArray = ownerIndex(users, owner)
        if(ownerIndexInUsersArray >= 0){
            const usersCopy = deepCopyObjectArray(users)
            usersCopy.splice(ownerIndexInUsersArray, 1)
            setUsers(usersCopy)
        }
    // XXX Fix this in the future
    // eslint-disable-next-line
    }, [users, owner])


    return (
        <div className={classes.root}>
            <CollapseForCard header={header} dataCount={assignedUserCount} onClick={openModal}>
                <List>
                    {owner && <UserListItem user={owner} />}
                    {users.map((user, index)=>(
                        <div key={user.user_id || index}>
                            <UserListItem user={user} index={index} deleteHandler={()=> deleteHandler(user.user_id)} />
                        </div>
                    ))}
                </List>
            </CollapseForCard>
            <div className={classes.errorMessageDiv}>
                <Text type='textFieldError'>{errorHandler()}</Text>
            </div>
            <SelectUsersModal owner={owner} users={users} setUsers={setUsers} open={open} setOpen={setOpen} />
        </div>
    )
}

export default AssignOwner

const useStyles = makeStyles({
    root: {},
    errorMessageDiv: {
        margin: '0 14px'
    }
})
